let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gWuAm")).then(() => parcelRequire('6fgzU'));